import { scrollToFeedbackMessage } from '@modules/feedback/components/AudioType/utils';

export const scrollToPlayingAudioTranscriptMessage = (msgIndex: number) => {
  scrollToFeedbackMessage(msgIndex.toString(), 'data-audio-message-id');
};
